<template>
  <div>
    <div
      class="q-pa-md flex flex-center"
      style="min-height: 300px"
      padding
    >
      <q-stepper
        v-model="step"
        ref="stepper"
        color="primary"
        animated
      >
        <q-step
          :name="1"
          title="Import"
          icon="sync_alt"
          :done="step > 1"
          style="height: 75vh"
          :disable="sessionList.length !== 0 ? false : ''"
        >
          <h6>Start a New Session by Importing an Existing Session or Start From Scratch.</h6>
          <q-checkbox
            v-model="isImportingSession"
            @click="isImportingSession ? '' : clearStepperDetails()"
            label="Would You Like to Import an Existing Session as a Base?"
          />
          <br />
          <div v-if="isImportingSession">
            <div class="text-body1">
              Please select which session you would like to use as a base from below:
            </div>
            <br />
            <div>
              <q-list
                bordered
                separator
              >
                <q-item
                  clickable
                  v-ripple
                  v-for="session in sessionList"
                  :key="session.sessionId"
                  :active="importSelected === session.sessionName"
                  @click="updateImportSession(session)"
                  active-class="menu-link"
                >
                  <q-item-section> {{ session.sessionName }} </q-item-section>
                </q-item>
              </q-list>
            </div>
          </div>
        </q-step>
        <q-step
          :name="2"
          title="Basic Information"
          icon="date_range"
          :done="step > 2"
          class="flex flex-center"
        >

          <SubmitSession
            ref="submitSessionForm"
            :isCreation="true"
          />
          <!-- <StudentInformation @AddApplicationDetails="AddToApplication($event)" /> -->
        </q-step>

        <q-step
          :name="3"
          title="Complexes and Units"
          icon="home_work"
          :done="step > 3"
        >
          <ComplexesTreeSelector />
        </q-step>

        <template v-slot:navigation>
          <q-stepper-navigation>
            <q-btn
              v-if="step > 1"
              flat
              color="primary"
              @click="$refs.stepper.previous()"
              label="Back"
              class="q-ml-sm"
              no-caps
            />
            <q-btn
              type="submit"
              @click="StepForward(step)"
              color="primary"
              :label="step === 3 ? 'Finish' : 'Continue'"
              class="q-ml-sm"
              no-caps
            />
          </q-stepper-navigation>
        </template>
      </q-stepper>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useQuasar } from 'quasar';

import useComplexTree from '@/hooks/complexTree';
import useSession from '@/hooks/session';
import useUiUtilities from '@/utilities/uiUtilities';
import SubmitSession from './SubmitSession.vue';
import ComplexesTreeSelector from './ComplexesTreeSelector.vue';

export default {
  async setup() {
    const router = useRouter();
    const $q = useQuasar();

    const {
      createSession,
      sessionDetails,
      sessionId,
      fetchSessionNameIds,
      sessionNameIds,
      isSessionFormValid,
      resetSession,
    } = useSession();
    const { complexTree, ticked } = useComplexTree();
    const { notifyResult } = useUiUtilities();

    const submitSessionForm = ref();
    sessionId.value = 0;
    const isImportingSession = ref(false);
    ticked.value = [];
    const importSelected = ref('None');
    const stepper = ref();
    const step = ref(1);
    const sessionList = ref([]);

    onMounted(async () => {
      await fetchSessionNameIds();

      sessionList.value = sessionNameIds.value;
      step.value = sessionList.value.length === 0 ? 2 : 1;
    });

    const clearStepperDetails = async () => {
      await resetSession();
      ticked.value = [];
      isImportingSession.value = false;
      importSelected.value = 'None';
    };
    clearStepperDetails();

    const validateSession = async (validateForm) => {
      await validateForm.value.onValidate();
      // $q.notify({
      //   spinner: true,
      //   message: 'Please wait...',
      // });
    };

    const StepForward = async (nextStep) => {
      $q.loading.show();

      window.scrollTo(0, 0);
      let goToNextStep = true;

      if (nextStep === 2) {
        await validateSession(submitSessionForm);
        goToNextStep = isSessionFormValid.value;
      } else if (nextStep === 3) {
        sessionDetails.value.complexTree = complexTree.value;
        sessionDetails.value.ticked = ticked.value;
        const createResponse = await createSession();
        notifyResult(createResponse.status, createResponse);
        if (createResponse && createResponse.status === 200) {
          router.push('/sessions');
        }
      }

      if (goToNextStep) {
        stepper.value.next();
      }

      $q.loading.hide();
    };

    const updateImportSession = (prevSession) => {
      importSelected.value = prevSession.sessionName;
      sessionId.value = prevSession.sessionId;
    };

    return {
      step,
      updateImportSession,
      StepForward,
      isImportingSession,
      sessionList,
      importSelected,
      clearStepperDetails,
      submitSessionForm,
      stepper,
    };
  },
  components: {
    SubmitSession,
    ComplexesTreeSelector,
  },
};
</script>
